define('lib/fileuploader/base',['require','translate','underscore','jquery','lib/Podio.FileUploader','lib/fileuploader/file','lib/Podio.UI.FileFinder'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var FileUploader = require('lib/Podio.FileUploader');
  var FileUploaderFile = require('lib/fileuploader/file');

  var defaultOptions = {
    elmListContainer: null,
    elmDropContainer: null,
    showDialogOnInit : false,
    showDragDropTip : true,
    useFileFinder: false,
    onlyAllowImages: false,
    onlyAllowVideos: false,
    allowedMimeTypes: []
  };

  var templates = {
     item : _.template('<li class="podio-uploader-file <%= style %> " data-id="<%= file.id %>" data-file-id="<%= file.fileId %>" data-mime="<%= file.mimeType %>"><% if (enableDelete) { %><a class="remove remove-attachment-close-link"><span class="icon-16 icon-x-black2"></span></a><% } %></li>'),
     itemList : _.template('<ul class="podio-uploader-list empty"></ul>'),
     dropZone : _.template('<div class="dropzone">' + t('Drop the files here #uploader') + '</div>'),
     container : _.template('<div class="podio-uploader-box"></div>'),
     buttonContainer : _.template('<div class="button-wrapper image-block"></div>'),
     errorContainer : _.template('<ul class="error-container hidden"></ul>'),
     dragndropTipBox : _.template('<div class="bd"><div class="files-drag-tip image-block"> <span class="img space-right icon-16 icon-16-drag-hand"></span><span class="bd">' + t("Drag'n drop files here to upload #uploader") + '</span></div></div>'),
     previewIcon : _.template('<div class="icon-32 <%= file.icon %> tooltip" title="<%=file.name%>"></div>'),
     previewImage : _.template('<img src="<%= file.thumbnail_link %>" />'),
     previewPending : _.template('<div class="icon-16 icon-spinner"></div><div class="progress-bar"><div class="bar"></div></div>')
  };

  var PodioBaseUploader = function(elmTarget, options) {
    var that = this;

    this.options = $.extend(true, {}, defaultOptions, options);

    this.templates = templates;

    this.elmTarget = elmTarget;
    this.elmHiddenInput = this.options.elmHiddenInput || [];
    this.elmContainer = null;
    this.elmUploadButton = null;
    this.elmButtonWrapper  = null;
    this.elmList  = null;
    this.elmDropzone = null;
    this.elmErrorContainer  = null;

    this.uploader = new FileUploader(elmTarget, options);

    this.uploader.signals.onPostInit.add(function() {

      if(that.uploader.isDragDropSupported() ) {

        that.elmButtonWrapper.append(templates.dragndropTipBox());

      } else {

        if( this.elmDropzone && this.elmDropzone.length ) {
          this.elmDropzone.remove();
        }

      }

      if(!that.uploader.runtime) {
        // No runtime, no uploader working, hiding the button (for mobile devices)
        that.elmButtonWrapper.hide();
      }

    });

    this.uploader.signals.onFileAdded.add(function(file) {
      that.elmList.removeClass('empty');
      that.elmErrorContainer.addClass('hidden').empty();

      var elmFile = $(that.templates.item({ file : file, enableDelete: false, style : 'pending' }));
          elmFile.append(that.templates.previewPending());
          elmFile.appendTo(that.elmList);
    });

    this.uploader.signals.onUploadProgress.add(function(file) {
      var elmFile = that.elmList.find('li[data-id=' + file.id + ']');
          elmFile.find('.progress-bar .bar').width(file.percent+'%');
    });

    this.uploader.signals.onFileUploaded.add(function(file) {
      that.elmList.removeClass('empty');
      that.elmList.find('li[data-id=' + file.id + ']').remove();
    });

    this.uploader.signals.onError.add(function(error) {
      var file = error.file;

      if(file) {
        var elmPendingFile = that.elmList.find('li[data-id=' + file.id + ']');
        elmPendingFile.remove();
      }

      that.elmErrorContainer.removeClass('hidden');

      var errorMessage = error.message;
      var errorDetails = (error.details || '');
      var errorStatusCode = (error.status || '');
      var fileName = file ? '<strong class="text-bold">' + file.name.htmlEncode() + '</strong>' : '';

      switch(error.code) {
        case window.plupload.INIT_ERROR:
          errorMessage = t('Uploader failed to start ({0}) #uploader').format(error.message);
          break;
        case window.plupload.GENERIC_ERROR:
          errorMessage = t('{0} failed with an error ({1}) #uploader').format(fileName, errorDetails);
          break;
        case window.plupload.FILE_SIZE_ERROR:
          errorMessage = t('{0} is too large to upload (Over 100mb) #uploader').format(fileName);
          break;
        case window.plupload.IO_ERROR:
          errorMessage = t('{0} failed with an IO error ({1}) #uploader').format(fileName, errorDetails);
          break;
        case window.plupload.SECURITY_ERROR:
          errorMessage = t('{0} failed with an Security error ({1}) #uploader').format(fileName, errorDetails);
          break;
        case window.plupload.HTTP_ERROR:
          errorMessage = t('{0} failed with an HTTP error ({1}) #uploader').format(fileName, errorStatusCode);
          break;
        case window.plupload.FILE_EXTENSION_ERROR :
          if (that.options.onlyAllowImages) {
            errorMessage = t('{0} is not a valid image file #uploader').format(fileName);
          } else {
            errorMessage = t('{0} has an unsupported file extension #uploader').format(fileName);
          }
          break;
      }

      that.elmErrorContainer.append('<li>' + errorMessage + '</li>');
    });

    this.uploader.signals.onDragEnter.add(function(elmDropZone) {
      elmDropZone.addClass('enter');
    });

    this.uploader.signals.onDragLeave.add(function(elmDropZone) {
      elmDropZone.removeClass('enter');
    });

    this.uploader.signals.onDocDragEnter.add(function(elmDropZone) {
      that.elmContainer.addClass('dropzone-active');
      elmDropZone.addClass('active');
    });

    this.uploader.signals.onDocDragLeave.add(function(elmDropZone) {
      that.elmContainer.removeClass('dropzone-active');
      elmDropZone.removeClass('active enter');
    });

    this.uploader.signals.onDocDragEnd.add(function(elmDropZone) {
      that.elmContainer.removeClass('dropzone-active');
      elmDropZone.removeClass('active enter');
    });

    this.uploader.signals.onPostInit.add(function() {
      if(options.showDialogOnInit) {
        that.showDialog();
      }
    });

    this.showDialog = function() {
      if(options.useFileFinder) {
        that.showFileFinder();
      } else {
        that.uploader.showDialog();
      }
    };

    this.showFileFinder = function() {

      var FileFinder = require('lib/Podio.UI.FileFinder');

      if(!this.fileFinder) {

        var fileFinderOptions = {
          onlyAllowImages   : options.onlyAllowImages,
          onlyAllowVideos   : options.onlyAllowVideos,
          allowedMimeTypes  : options.allowedMimeTypes,
          multipleFiles     : options.multipleFiles,
          onlyPodioFiles    : options.onlyPodioFiles,
        };

        this.fileFinder = new FileFinder(fileFinderOptions);

        this.fileFinder.signals.onDone.removeAll();
        this.fileFinder.signals.onDone.add(function(files) {

          _.each(files, function(file) {
            var uFile = new FileUploaderFile().createFromPodioFile(file);

            that.signals.onBeforeFileAdded.dispatch(uFile);
            that.signals.onFileAdded.dispatch(uFile);
            that.signals.onFileUploaded.dispatch(uFile);

          });

          that.signals.onUploadFinished.dispatch([]);

        });
      }

      this.fileFinder.init();
    };

    this.onFileFinderButtonClick = function(e) {
      that.showFileFinder();

      return false;
    };

    return _.defaults(this, this.uploader);
  };

  PodioBaseUploader.prototype.init = function() {

    this.elmTarget.wrapInner(templates.container());

    this.elmContainer = this.elmTarget.find('.podio-uploader-box');

    this.elmUploadButton = this.elmTarget.find('.uploader-button');
    this.elmUploadButton.wrap(templates.buttonContainer());
    this.elmUploadButton = this.elmTarget.find('.uploader-button');
    this.elmUploadButton.addClass('img');
    this.elmButtonWrapper =  this.elmTarget.find('.button-wrapper');

    if(!this.elmUploadButton.length) {
      return;
    }

    if(this.options.useFileFinder) {

      this.elmUploadButton.removeClass('uploader-button');
      this.elmUploadButton.addClass('upload-file-finder-button');

      var elmFakeUploadButton = $('<div />', { 'class' : 'uploader-button hidden'});
      elmFakeUploadButton.appendTo(this.elmButtonWrapper);

      this.elmButtonWrapper.delegate('.upload-file-finder-button', 'click', this.onFileFinderButtonClick);

    }


    this.elmList = (this.options.elmListContainer ? this.options.elmListContainer : this.elmTarget).find('.podio-uploader-list');
    if( !this.elmList.length ) {
        // No existing list, create it
      this.createList();
    }
    this.elmDropzone = this.options.elmDropContainer ? $(templates.dropZone()).appendTo(this.options.elmDropContainer) : $(templates.dropZone()).insertBefore(this.elmButtonWrapper);
    this.elmErrorContainer = $(templates.errorContainer()).insertBefore(this.elmList);

    if(this.options.skin) {
      this.elmContainer.addClass(this.options.skin);
    }

    this.uploader.init();
  };

  PodioBaseUploader.prototype.createList = function() {
    this.elmList = this.options.elmListContainer ? $(templates.itemList()).appendTo(this.options.elmListContainer) : $(templates.itemList()).insertBefore(this.elmButtonWrapper);
  };

  PodioBaseUploader.prototype.updateFormValue = function() {
    if(!this.elmHiddenInput.length) {
      return;
    }

    var fileIds = _.map(this.elmList.find('> li:not(.error)'), function(item) {
      return $(item).data('file-id');
    });

    this.elmHiddenInput.val(fileIds.join(','));
  };

  PodioBaseUploader.prototype.clearAll = function() {
    if(this.elmList) {
      this.elmList.empty();
      this.elmList.addClass('empty');
    } else {
      this.createList();
    }

    this.uploader.refresh();

    this.updateFormValue();
  };

  PodioBaseUploader.prototype.dispose = function() {

    // Remove DOM elements
    if( this.elmList && this.elmList ) {
      this.elmList.remove();
    }

    if( this.elmContainer  && this.elmContainer.length ) {
      this.elmContainer.remove();
    }

    if( this.elmUploadButton && this.elmUploadButton.length ) {
      this.elmUploadButton.remove();
    }

    if( this.elmButtonWrapper && this.elmButtonWrapper.length ) {
      this.elmButtonWrapper.remove();
    }

    if( this.elmDropzone && this.elmDropzone.length ) {
      this.elmDropzone.remove();
    }

    if( this.elmErrorContainer && this.elmErrorContainer.length ) {
      this.elmErrorContainer.remove();
    }

    // Dispose uploader
    this.uploader.dispose();

  };

  return PodioBaseUploader;

});

